import { gql } from '@apollo/client'
import employeeSkillStatusFragment from './employeeSkillStatus.fragment'

export const PERSONAL_SKILL_STATUS_IN_MEETING_PREPARATION = gql`
  query GetPersonalSkillStatusInEmployeePreparation($id: HashedId!) {
    getPersonalSkillStatusInEmployeePreparation(id: $id) {
      ...SkillStatusFragment
    }
  }
  ${employeeSkillStatusFragment}
`

export const EMPLOYEE_SKILL_STATUS_IN_MEETING = gql`
  query GetEmployeeSkillStatusInMeeting($id: HashedId!) {
    getEmployeeSkillStatusInMeeting(id: $id) {
      ...SkillStatusFragment
    }
  }
  ${employeeSkillStatusFragment}
`

export const SKILL_STATUS_BLOCKS_MEETING = gql`
  query SkillStatusBlocksMeeting($meetingId: HashedId!) {
    skillStatusBlocksMeeting(meetingId: $meetingId)
  }
`

export const SKILL_STATUS_DATA_IN_MEETING_INVITATION = gql`
  query RetrieveSkillStatusDataInMeetingInvitation($employeeId: HashedId!) {
    retrieveSkillStatusDataInMeetingInvitation(employeeId: $employeeId) {
      skillEmployeeStatusDto {
        ...SkillStatusFragment
      }
      isSkillStatusBlocker
      retrievalError
    }
  }
  ${employeeSkillStatusFragment}
`
